var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-select",
    class: {
      'cm-select--compact': _vm.compact,
      'cm-select--tags': _vm.showTags
    },
    on: {
      "focusin": _vm.handleFocusin,
      "focusout": _vm.handleFocusout
    }
  }, [(_vm.showTags && _vm.multiple) ? _c('div', {
    staticClass: "cm-select__input-container"
  }, [_c('div', {
    staticClass: "cm-select__input-wrapper"
  }, [_vm._l((_vm.selectedOptions), function(tag) {
    return _c('cm-tag', {
      key: tag,
      staticClass: "cm-select__tag",
      attrs: {
        "value": tag.value,
        "label": tag.label,
        "theme": "panda"
      },
      on: {
        "delete": _vm.removeTag
      }
    })
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "searchInput",
    staticClass: "cm-select__input-container__search-input",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": _vm.buttonLabel
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.selectSibling(-1)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.selectSibling(1)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })], 2)]) : _c('button', {
    staticClass: "cm-select__button",
    attrs: {
      "type": "button"
    },
    on: {
      "focus": _vm.handleButtonFocus,
      "click": _vm.handleButtonFocus
    }
  }, [_vm._v("\n    " + _vm._s(_vm.buttonLabel) + "\n    "), _c('div', {
    staticClass: "cm-select__button-arrow"
  }, [_vm._v("\n      " + _vm._s(_vm.isOpen ? "navigateup" : "navigatedown") + "\n    ")])]), _vm._v(" "), _c('div', {
    ref: "popup",
    staticClass: "cm-select__popup",
    class: {
      'cm-select__popup--is-open': _vm.isOpen
    }
  }, [(_vm.includeSearch && !_vm.showTags) ? _c('div', {
    staticClass: "cm-select__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "searchInput",
    staticClass: "cm-select__search-input",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.selectSibling(-1)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.selectSibling(1)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cm-select__items"
  }, _vm._l((_vm.filteredOptions), function(option) {
    return _c('label', {
      key: option.value,
      staticClass: "cm-select__item",
      class: {
        'cm-select__item--is-selected': option.isSelected
      },
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
        },
        "click": _vm.handleOptionClick
      }
    }, [_c('input', {
      staticClass: "cm-select__item-input",
      attrs: {
        "type": _vm.multiple ? 'checkbox' : 'radio',
        "name": _vm.name
      },
      domProps: {
        "value": option.value,
        "checked": option.isSelected
      },
      on: {
        "change": function($event) {
          _vm.handleChange($event, option.value)
        },
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }), _vm._v("\n        " + _vm._s(option.label) + "\n        "), (option.isSelected) ? _c('span', {
      staticClass: "cm-select__check ss-icon"
    }, [_vm._v("check")]) : _vm._e()])
  }))])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25221494","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/select.vue
// module id = null
// module chunks = 